import { Box, Chip } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const BranchCode = styled("div")(() => ({
  display: "flex",
  padding: "2px 8px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  borderRadius: "6px",
  background: "#DC6803",
  color: "#FFF",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "24px",
}));

export const BranchChip = styled(Chip)(() => ({
  backgroundColor: "#EDF5FB",
  color: "#308cdb",
  margin: "2px",
}));

export const BranchBox = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  textOverflow: "ellipsis",
  height: 40,
  alignItems: "center",
}));

const styles = makeStyles(() => ({
  addBranchButton: {
    whiteSpace: "nowrap",
  },
  listSpan: {
    display: "flex",
    alignItems: "center",
    color: "#308CDB",
  },
  button: {
    whiteSpace: "nowrap",
  },
  loading: {
    height: "40px",
  },
  select: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    "& fieldset": {
      "& legend": {
        fontSize: 0,
        margin: 0,
        "& span": {
          display: "none",
        },
      },
    },
  },
}));

export default styles;
